import React from "react";
import PropTypes from "prop-types";

const TableRow = (props) => {
	return (<tr className="c-table-row " key={props.key} style={props.style}>
		{props.children}
	</tr>);
};

TableRow.propTypes = {
	children: PropTypes.node,
	key: PropTypes.string,
	style: PropTypes.string
};

export default TableRow;
